import { render, staticRenderFns } from "./frequencyDistrubution.vue?vue&type=template&id=827bc846&scoped=true&"
import script from "./frequencyDistrubution.vue?vue&type=script&lang=js&"
export * from "./frequencyDistrubution.vue?vue&type=script&lang=js&"
import style0 from "./frequencyDistrubution.vue?vue&type=style&index=0&id=827bc846&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "827bc846",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VProgressCircular,VRow,VSpacer})
